import { Component } from '@angular/core';

@Component({
  selector: 'lib-notification-bell-icon',
  standalone: true,
  imports: [],
  templateUrl: './notification-bell-icon.component.html',
  styleUrl: './notification-bell-icon.component.css'
})
export class NotificationBellIconComponent {

}
